import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  Input,
} from "reactstrap";
import * as Yup from "yup";
import moment from "moment";
import { Field, Formik } from "formik";
import { cloneDeep, find } from "lodash";

import useAxios from "hooks/useAxios";
import CoveredEntity from "components/CoveredEntity";
import Calendar from "assets/icon/calendar-icon.svg";
import useContextService from "hooks/useContextService";
import NPIProviderList from "components/NPIProviderList";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikInputField from "components/common/Fields/FormikInputField";
import PatientList from "components/PatientList";
import { default as ReactSelect } from "react-select";
import { Option, LimitedChipsContainer } from "components/Options";
import { components } from "react-select";
import { ModuleAccess } from "utils/moduleaccess";
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";

let hasDatePopupOpen = false;

let pharmacyData = [];
let ClaimStatusData = [];

let coveredentityError = ""
// const validationSchema = Yup.object({
//   coveredEntityID: Yup.string().required("Please select covered entity"),
// });

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

const SearchContainer = (props) => {
  const API = useAxios();
  const {
    states: { claimsManager },
    setStates,
    resetStates,
  } = useContextService();
  const [claimStatusList, setClaimStatus] = useState([]);
  const { onSearch, onReset, onManualbulkUpdate, onManualSearch, orgId, isProviderEmpty, isPatientEmpty } =
    props;
  const [selectedOption, setOptionSelected] = useState({
    optionSelected: "-1",
  });
  const prevOrgId = usePrevious(orgId);
  const [selectedOpt, setOptSelected] = useState({ optSelected: "-1" });
  const [submit, setSubmit] = useState(false);

  const { pharmacies, coveredEntity, searchTerms, patient, provider } =
    claimsManager;

  let {
    coveredEntityID,
    pharmacyID,
    patientID,
    providerID,
    claimStatusID,
    startDate,
    endDate,
    pharmacyIds,
    claimStatusIds,
  } = searchTerms;
  const { tenantID } = coveredEntity;
  const [rxNumber, setRxNumber] = useState(claimsManager?.searchTerms?.rxNumber)


  let selectedCE =
    coveredEntityID === "" || isNaN(coveredEntityID)
      ? window.selectedCoveredEntittyId
      : coveredEntityID;

  useEffect(() => {
    fetchClaimStatus();
    coveredentityError = ""
  }, []);

  const hasPermission = (code) => {
    return ModuleAccess("CLM", code);
  };
  const fetchClaimStatus = async () => {
    try {
      const { data } = await API.get("RCMConfig/TypeStatus/ClaimStatus", {
        hasDefaultURL: true,
      });
      if (data) {
        if (ClaimStatusData.length == 0) {
          for (var x in data) {
            ClaimStatusData.push({
              value: data[x].id,
              label: data[x].description,
            });
          }
        }
        if (claimsManager.searchTerms.claimStatusID != "" || claimsManager.searchTerms.claimStatusIds.length>0) {
          if (claimStatusIds) {
            var claimstatusSelected = {};
            claimstatusSelected.optSelected = [];
            for (var x in claimStatusIds) {
              claimstatusSelected.optSelected.push(claimStatusIds[x]);
            }
            setOptSelected(claimstatusSelected);
          }
        }
        setClaimStatus(data);
      } else {
        setClaimStatus([]);
      }
    } catch (error) { }
  };

  const updateStates = (claimsManager) => {
    setStates("claimsManager", claimsManager);
  };

  const handleSubmit = async (val, actions) => {
    let pharmacyIDs = [];

    for (var x in selectedOption.optionSelected) {
      var rw = selectedOption.optionSelected[x];
      pharmacyIDs.push(rw.value);
    }
    let claimstatusIDs = [];
    for (var x in selectedOpt.optSelected) {
      var rw = selectedOpt.optSelected[x];
      claimstatusIDs.push(rw.value);
    }
    const { setSubmitting } = actions;
    const values = cloneDeep(val);
    values.providerNPI = providerID;
    if (pharmacyIDs > [0]) values.pharmacyIDs = pharmacyIDs;
    if (patientID) values.patientID = patientID;
    if (claimstatusIDs > [0]) values.claimstatusIDs = claimstatusIDs;
    if (startDate) values.startDate = startDate;
    if (endDate) values.endDate = endDate;
    values.rxNumber = rxNumber
    if (claimstatusIDs.length == 1) {
      const selectstatus = selectedOpt.optSelected;
      claimsManager.statusname = selectstatus[0].label;
      claimsManager.searchTerms.claimStatusID = selectstatus[0].value;
      var claimstsId = selectstatus[0].value;
      setSubmit(true);
    }
    claimsManager.search.currentPage = 1;

    if (coveredEntityID == "" && searchTerms.coveredEntityID == "") {
      coveredentityError = "Please select Covered Entity"
    }
    updateStates(claimsManager);
    await onSearch(values, claimstsId);
    setSubmitting(false);
  };

  const onSelectPatient = (patient) => {
    if (patient) {
      claimsManager.patient = patient;
      claimsManager.searchTerms.patientID = patient.id;
      isPatientEmpty(null);
    } else {
      claimsManager.patient = "";
      claimsManager.searchTerms.patientID = "";
      isPatientEmpty("");
    }
    updateStates(claimsManager);
  };

  const handleCoverdEntityChange = async (value, setFieldValue, entity) => {
    window.selectedCoveredEntittyId = value;
    coveredentityError = ''

    if (entity) {
      const { coveredEntityID } = entity;
      setFieldValue("coveredEntityID", value);
      pharmacyData = [];
      claimsManager.coveredEntity = entity;
      if (claimsManager.searchTerms.coveredEntityID != parseInt(value)) {
        pharmacyIds = {};
        // claimsManager.searchTerms.pharmacyIds = {};
        // claimStatusIds = {};

        claimsManager.searchTerms.claimStatusIds = {};
      }
      claimsManager.searchTerms.coveredEntityID = coveredEntityID;
      fetchPharmacyName(coveredEntityID);
      setOptionSelected({ optionSelected: "-1" });
    } else {
      setFieldValue("coveredEntityID", "");
      pharmacyData = [];
      claimsManager.coveredEntity = {};
      claimsManager.searchTerms.coveredEntityID = "";
      claimsManager.searchTerms.pharmacyIds = {};
    }
    updateStates(claimsManager);
  };

  const fetchPharmacyName = async (coveredEntityID) => {

    try {
      const { data } = await API.get(
        `RCMConfig/coveredentity/pharmacies/${coveredEntityID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
        claimsManager.pharmacies = data;
        updateStates(claimsManager);
        if (pharmacyIds) {
          var pharmacySelected = {};
          pharmacySelected.optionSelected = [];
          for (var x in pharmacyIds) {
            pharmacySelected.optionSelected.push(pharmacyIds[x]);
          }
          //setOptionSelected({ optionSelected: [{ "value": 1003387697, "label": "Creekside Pharmacy" }, { "value": 1710081534, "label": "CVS 02540" }, { "value": 1043589062, "label": "Medicine Cabinet Pharmacy" }] });
          setOptionSelected(pharmacySelected);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const bulkUpdates = async () => {
    await onManualbulkUpdate();
  };
  const handlePharmacyChange = (selected) => {
    setOptionSelected({
      optionSelected: selected,
    });
    claimsManager.searchTerms.pharmacyIds = selected;
    updateStates(claimsManager);
  };
  const handleClaimStatusChange = (selected) => {
    setOptSelected({
      optSelected: selected,
    });
    setSubmit(false);
    claimsManager.searchTerms.claimStatusIds = selected;
    updateStates(claimsManager);
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const onSelect = (provider) => {
    if (provider) {
      claimsManager.provider = provider;
      claimsManager.searchTerms.providerID = provider.id;
      isProviderEmpty(null);
    } else {
      claimsManager.provider = "";
      searchTerms.providerID = "";
      provider = "";
      providerID = "";
      claimsManager.searchTerms.providerID = "";
      isProviderEmpty("");
    }
    updateStates(claimsManager);
  };
  console.log(claimsManager, "claims")

  const handleOnChange = ({ target: { value } }) => {
    claimsManager.searchTerms.rxNumber = value;
    setRxNumber(value)
    updateStates(claimsManager);
  };

  const handleStartDate = (startDate) => {
    claimsManager.searchTerms.startDate = moment(new Date(startDate)).format(
      "MM/DD/YYYY"
    );
    updateStates(claimsManager);
  };

  const handleEndDate = (endDate) => {
    claimsManager.searchTerms.endDate = moment(new Date(endDate)).format(
      "MM/DD/YYYY"
    );
    updateStates(claimsManager);
  };

  const handleCombo = async () => {
    await onManualSearch();
  };

  const handleReset = ({ resetForm }) => {
    pharmacyData = [];
    window.selectedCoveredEntittyId = "";
    searchTerms.coveredEntityID = ""
    claimsManager.coveredEntity = {};
    resetForm();
    onReset();
    setOptionSelected({ optionSelected: "-1" });
    claimsManager.searchTerms.pharmacyIds = {};
    setOptSelected({ optSelected: "-1" });
    coveredentityError = ""
    claimsManager.searchTerms.rxNumber = "";
    setRxNumber("");
    resetStates("claimsManager");
  };

  const resetFormbyOrgId = (props) => {
    handleReset(props);
    selectedCE = ""
  }

  return (
    <Formik
      initialValues={searchTerms}
      onSubmit={handleSubmit}
      // validationSchema={validationSchema}
      enableReinitialize={true}
      children={(props) => {
        const { isSubmitting, handleSubmit, resetForm, setFieldValue } = props;
        useEffect(() => {
          if (prevOrgId !== undefined && prevOrgId !== null && orgId !== undefined && orgId !== null && prevOrgId !== orgId) {
            resetFormbyOrgId(props);
          }
        }, [orgId, prevOrgId]);
        return (
          <div>
            <h5 className="f-16 text-primary font-weight-700">
              Search Claims Manager
            </h5>
            <Row>
              <Col md={3} sm={3} xs={6}>
                {" "}
                <FormGroup>
                  <Label for="coveredEntityID">Covered Entity</Label>
                  <CoveredEntity
                    value={selectedCE}
                    name="coveredEntityID"
                    orgId={orgId}
                    onChange={(value, enty) =>
                      handleCoverdEntityChange(value, setFieldValue, enty)
                    }
                  />
                  {(coveredentityError.length > 0) ? (<div className="text-danger f-12">
                    {coveredentityError}
                  </div>) : null}
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={6}>
                {" "}
                <FormGroup>
                  <Label for="pharmacyID">Pharmacy Name</Label>
                  <ReactSelect
                    name="pharmacyID"
                    options={pharmacyData}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handlePharmacyChange}
                    value={selectedOption.optionSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option: (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={6}>
                <FormGroup>
                  <Label for="patientID">Patient Name</Label>
                  <PatientList
                    tenantID={tenantID}
                    onSelect={onSelectPatient}
                    selectedPatient={patient}
                  />
                </FormGroup>
              </Col>

              <Col md={3} sm={3} xs={6}>
                {" "}
                <FormGroup>
                  <Label for="rxNumber">Rx#</Label>
                  <Input
                    id="rxNumber"
                    name="rxNumber"
                    type="text"
                    value={rxNumber}
                    autoComplete="off"
                    // value=""
                    // component={FormikInputField}
                    onChange={handleOnChange}
                    placeholder="Enter Rx#"
                  />
                </FormGroup>
              </Col>

              <Col md={3} sm={3} xs={6}>
                <FormGroup>
                  <Label>NPI/Provider Name</Label>
                  <NPIProviderList
                    tenantID={tenantID}
                    onSelect={onSelect}
                    selectedProvider={provider}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={6}>
                <FormGroup>
                  <Label>Status</Label>
                  <ReactSelect
                    name="claimStatus"
                    options={ClaimStatusData}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handleClaimStatusChange}
                    value={selectedOpt.optSelected}
                    maxMenuHeight={220}
                    className="claim_info"
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option: (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6} xs={6}>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Start Date</Label>
                      <InputGroup onMouseLeave={handleMouseLeave}>
                        <Field
                          type="text"
                          id="startDate"
                          name="startDate"
                          autoComplete="off"
                          placeholder="Select a date"
                          value={startDate}
                          component={FormikDatePicker}
                          onChange={handleStartDate}
                        />
                        <InputGroupText
                          onClick={() => handleDateClick("startDate")}
                        >
                          <img src={Calendar} alt="" />
                        </InputGroupText>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col xs="auto" className="pt-3 mt-3">
                    <Label className="mt-1">-</Label>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>End Date</Label>
                      <InputGroup onMouseLeave={handleMouseLeave}>
                        <Field
                          type="text"
                          id="endDate"
                          name="endDate"
                          autoComplete="off"
                          placeholder="Select a date"
                          value={endDate}
                          component={FormikDatePicker}
                          onChange={handleEndDate}
                        />
                        <InputGroupText
                          onClick={() => handleDateClick("endDate")}
                        >
                          <img src={Calendar} alt="" />
                        </InputGroupText>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row
              style={{
                justifyContent: "flex-end",
                // marginRight: "10px",
              }}
            >
              <Col md="auto">
                <Label>{""}</Label>
                <Button
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  color="primary"
                  className="search"
                >
                  <span className="right_5">
                    <img src={search} alt="" />
                  </span>{" "}
                  Search
                </Button>
                <Button
                  color="primary"
                  onClick={() => handleReset(props)}
                  className="reset ms-2"
                >
                  <span className="right_5">
                    <img src={reseticon} alt="" />
                  </span>{" "}
                  Reset
                </Button>
                {/* <Button color='primary' 
                onClick={bulkUpdates} disabled={!((selectedOpt.optSelected.length == 1) && (coveredEntityID) && (submit == true))} >
                    Bulk Update
                  </Button> */}
                {/* <Button 
                disabled={!selectedCE}
                    onClick={handleCombo}
                    color="primary"
                    className="ms-3"
                  // hidden={!hasPermission('PPB')}
                  >
                    AUTO APPROVAL

                  </Button> */}
              </Col>
            </Row>
          </div>
        );
      }}
    ></Formik>
  );
};

export default SearchContainer;
